// components/ActivityTabContent.jsx
import React, { useEffect, useState } from "react";
import ActivityHeader from "./ActivityHeader";
import ActivityTable from "./ActivityTable";
import MobileActivityList from "./MobileActivityList";
import PaginationSection from "../../../../../shared/PaginationSection";
import { apiRequest } from "../../../../../api/apiService";
import { ACTIVITY_QUERY } from "../../../../../api/queries";
import { unifarmFactory } from "../../../../../utils/contract";
import { formatUnits } from "viem"; // ✅ use formatUnits instead of formatEther

export default function ActivityTabContent({
  by,
  contractAddress,
  token,
  tokenDecimals = 18, // ✅ default to 18 if not provided
}) {
  const [allActivities, setAllActivities] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    if (by && contractAddress) {
      getMyActivities();
    }
  }, [by, contractAddress, currentPage, perPage]);

  const getMyActivities = async () => {
    try {
      const skip = (currentPage - 1) * perPage;
      const first = perPage;
      setLoading(true);

      const response = await apiRequest({
        url: unifarmFactory.rootTokens,
        method: "POST",
        data: {
          query: ACTIVITY_QUERY,
          variables: {
            where: {
              by: by,
              contract: contractAddress,
            },
            skip,
            first,
            orderBy: "blockTimestamp",
            orderDirection: "desc",
          },
        },
        auth: false,
      });

      const stakeDatas = response?.data?.stakeDatas || [];
      // console.log(stakeDatas, "Raw stakeDatas");

      // ✅ Format your stake data for UI
      const formatted = stakeDatas.map((item) => {
        const date = new Date(Number(item.blockTimestamp) * 1000);
        const formattedDate = date.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        // ✅ Use formatUnits for correct decimals
        const formattedAmount = formatUnits(
          item?.amount || "0",
          tokenDecimals
        );

        return {
          date: formattedDate,
          time: formattedTime,
          amount: formattedAmount,
          contract: item.contract,
          type: item.type,
          txHash: item.transactionHash,
        };
      });

      setAllActivities(formatted);
      setTotalItems(stakeDatas.length || 0);
    } catch (err) {
      console.error("Error fetching activities:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="right_side_data">
      <div className="activity_Div newsideee">
        <ActivityHeader />
      </div>

      <div className="simple_table">
        <ActivityTable activities={allActivities} token={token} />
        <PaginationSection
          currentPage={currentPage}
          totalItems={totalItems}
          perPage={perPage}
          onPageChange={(page) => setCurrentPage(page)}
          onPerPageChange={(val) => {
            setPerPage(val);
            setCurrentPage(1);
          }}
        />
      </div>

      <div className="parent">
        <MobileActivityList activities={allActivities} />
      </div>
    </div>
  );
}
